import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface LoginForm {
    phone: string;
    password: string;
}

@Injectable({
    providedIn: 'root',
})
export class ApiService {
    private readonly apiUrl: string = environment.API_URL;

    constructor(private http: HttpClient) { }

    get(endPoint: string): Observable<any> {
        return this.http.get(this.apiUrl + endPoint);
    }

    post(endPoint: string, body: any): Observable<any> {
        return this.http.post(this.apiUrl + endPoint, body);
    }

    put(endPoint: string, body: any): Observable<any> {
        return this.http.put(this.apiUrl + endPoint, body);
    }

    delete(endPoint: string): Observable<any> {
        return this.http.delete(this.apiUrl + endPoint);
    }

}